export const _setTrackingForm = (state, action) => action.payload;

export const _setIsNewTracking = (state, action) => {
  state.isNewTracking = action.payload;
};
